import React from "react";

/** Tints the selected key without covering its label or intercepting pointer input. */
export function ButtonSelectionOverlay({ selected, x, y, width, height }: {
  selected: boolean;
  x: number;
  y: number;
  width: number;
  height: number;
}) {
  if (!selected) return null;
  return <rect data-button-selection="true" x={x} y={y} width={width} height={height} rx={4}
    fill="#ffbe73" fillOpacity={0.5} pointerEvents="none" />;
}
